import { FC, PropsWithChildren, ReactNode } from 'react';
import cls from 'classnames';
import styles from './index.module.scss';

interface IProps {
  title?: ReactNode;
  tabs?: ReactNode;
  action?: ReactNode;
  clsName?: string;
  noHeader?: boolean;
  full?: boolean;
  id?: string;
}

export const Block: FC<PropsWithChildren<IProps>> = ({
  title,
  tabs,
  action,
  clsName,
  children,
  noHeader,
  full,
  id,
}) => {
  return (
    <div
      className={cls(styles.block, clsName, { [styles.full]: !!full })}
      id={id}
    >
      <div
        className={styles.header}
        style={{ display: noHeader ? 'none' : 'flex' }}
      >
        {tabs ? <div className={styles.tabs}>{tabs}</div> : null}
        {title ? <div className={styles.title}>{title}</div> : null}
        {action ? <div className={styles.action}>{action}</div> : null}
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
